import { useEffect, useState } from "react";

/**
 * Returns true after `timeoutMs` of `isLoading` being true continuously.
 * Resets to false whenever isLoading becomes false.
 * Used to surface a "taking longer than expected" UI affordance + Reload action.
 */
export function useSlowLoadingFlag(isLoading: boolean, timeoutMs: number = 30_000): boolean {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setSlow(false);
      return;
    }
    const id = window.setTimeout(() => setSlow(true), timeoutMs);
    return () => window.clearTimeout(id);
  }, [isLoading, timeoutMs]);

  return slow;
}
